import React from "react";

// `step` is the currently-active step (1..3). Pass 4 to mark the third
// step as "done" too — used when phase === "generated" so the indicator
// reads as fully complete rather than still active at step 3.
interface PlanModeProgressProps {
  step: 1 | 2 | 3 | 4;
}

const STEPS = [
  { num: 1, label: "Échanges" },
  { num: 2, label: "Plan" },
  { num: 3, label: "Projet généré" },
];

const PlanModeProgress: React.FC<PlanModeProgressProps> = ({ step }) => {
  return (
    <div className="flex items-center justify-center gap-2 mb-3 px-2 py-2 bg-gray-50 rounded-lg border border-gray-200">
      {STEPS.map((s, i) => {
        const isActive = step === s.num;
        const isDone = step > s.num;
        return (
          <React.Fragment key={s.num}>
            <div className="flex items-center gap-2">
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium ${
                  isDone
                    ? "bg-green-500 text-white"
                    : isActive
                    ? "bg-purple-500 text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {isDone ? "✓" : s.num}
              </span>
              <span
                className={`text-xs ${isActive ? "font-medium text-gray-800" : "text-gray-500"}`}
              >
                {s.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <span
                className={`flex-1 h-px max-w-[40px] ${
                  step > s.num ? "bg-green-500" : "bg-gray-300"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PlanModeProgress;
